import { StrictMode } from 'react';

import { EloProvider, R1000Theme } from '@plurall/elo-v3';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import ReactDOM from 'react-dom/client';

import { AnalyticsProvider } from '@/features/analytics/AnalyticsProvider';
import { queryClient } from '@/lib/queryClient';
import { UserProvider } from '@/store/userStore';
import './styles/index.scss';

// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Create a router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <EloProvider
      defaultTheme='light'
      theme={R1000Theme}>
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <UserProvider>
            <AnalyticsProvider router={router}>
              <RouterProvider router={router} />
            </AnalyticsProvider>
          </UserProvider>
        </QueryClientProvider>
      </StrictMode>
    </EloProvider>
  );
}
